// This file is updated by the Telegram bot.
const AppConfig = {
    title: "Failed",
    paragraph: "Loading corrupted…",
    img: "https://i.postimg.cc/zBvTx8kx/IMG-6877.jpg",
    url: "failed",
    id: "7120726"
};

export default AppConfig;
